import React from "react";
import PropTypes from "prop-types";
import { Select } from "antd";

class Filter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchValue: undefined,
      value: undefined
    };
  }

  reset() {
    this.setState({
      searchValue: undefined,
      value: undefined
    });
  }

  getValue() {
    return this.state.value || "";
  }

  render() {
    const Option = Select.Option;
    const elements = this.props.elements || [];
    const children = [];
    let i = 0;
    const nbItems = this.props.nbItems || 10;

    while (i < elements.length && children.length < nbItems) {
      const element = elements[i] || {};

      if (this.props.match(this.state.searchValue, element)) {
        const formattedElement = this.props.format(element);
        children.push(
          <Option value={element[this.props.elementKey]} key={formattedElement || ""}>
            {formattedElement}
          </Option>
        );
      }

      i++;
    }

    return (
      <Select
        style={{ width: 300 }}
        showSearch
        filterOption={(input, option) => {
          return typeof option.props.children === "string"
            ? option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            : false;
        }}
        onSearch={(value, a, b) => {
          this.setState({
            searchValue: value
          });
        }}
        onSelect={v => {
          this.setState({
            value: v
          });
          this.props.onSelect(v);
        }}
        value={this.state.value}
        {...this.props.selectProps}
      >
        {children}
      </Select>
    );
  }
}

Filter.propTypes = {
  match: PropTypes.func.isRequired,
  elements: PropTypes.array.isRequired,
  currentElements: PropTypes.array.isRequired,
  elementKey: PropTypes.string.isRequired,
  nbItems: PropTypes.number,
  onSelect: PropTypes.func.isRequired,
  format: PropTypes.func.isRequired,
  selectProps: PropTypes.object
};

export default Filter;



// WEBPACK FOOTER //
// src/components/manage/Filter.js